<template lang="pug">
  div
    divider(:label="titulo", :tooltip="informacao")
    el-row
      app-upload-documentos(
        :id="idUploadDocumento",
        v-model="documentoSelecionado",
        :target="url",
        :fileType="validExtensions",
        :tiposDocumentos="tiposDocumentos",
        :maxSize="maxSize",
        :aba="aba",
        :required="tiposDocumentosObrigatorios && tiposDocumentosObrigatorios.length > 0",
        :documentos="documentos",
        :mensagensTipoDocumento="mensagensTipoDocumento",
        @anexar="anexar",
        @tipoDocumentoChange="tipoDocumentoOnChange"
      )

    el-row
      validation-provider(:rules="requireDocumentosObrigatorios()" v-slot="{ errors }", :name="aba + '/Documentos'")
        .input(:class="{'erro box-error' : errors.length}")
          el-table(
            :data='documentos',
            v-model="validationValues"
          )
            div(slot='empty')
              span Nenhum arquivo adicionado. Para adicionar um novo arquivo, selecione-o e clique no botão "Anexar".
            el-table-column(
              prop='tipoDocumento.descricao',
              label='Tipo de documento'
              align="left",
            )
            el-table-column(
              label='Anexos'
            )
              template(slot-scope='scope')
                el-tooltip(
                  v-if='scope.row.nome.length > 60'
                  :content="scope.row.nome"
                )
                  span {{ scope.row.nome.substring(0, 60) + '...' }}
                span(v-else) {{ scope.row.nome }}
            el-table-column(
              label='Ações',
              align="center",
              width="80"
            )
              template(slot-scope='scope')
                action-button(
                  icone="fa fa-times",
                  @click="deleteRow(scope.row, scope.$index)",
                  cor="#CF0021",
                  text="Remover documento"
              )
        span.help.erro {{ errors[0] }}
</template>

<script>
import AppUploadDocumentos from '@/components/AppUploadDocumentos'
import { ActionButton, Divider } from 'sicarf-components'

export default {
  components: {
    AppUploadDocumentos,
    ActionButton,
    Divider,
  },

  data() {
    return {
      nome: '',
      documentoSelecionado: null,
    }
  },

  props: {
    titulo: {
      type: String,
      default: 'Documentação'
    },
    idUploadDocumento: {
      type: String,
      default: 'appUploadDocumento'
    },
    documentos: {
      type: Array
    },
    tiposDocumentos: {
      type: Array,
      required: true
    },
    tiposDocumentosObrigatorios: {
      type: Array,
      required: false
    },
    url: {
      type: String,
      required: true
    },
    maxSize: {
      type: Number,
      default: 5000
    },
    aba: {
      type: String,
      required: true
    },
    validExtensions: {
      type: Array,
      required: false,
      default: () => ['pdf', 'rar', 'zip', 'png', 'jpg', 'jpeg', 'pdf', 'doc', 'docx']
    },
    mensagensTipoDocumento: {
      type: Object
    }
  },

  computed: {
    informacao () {
      if (this.tiposDocumentosObrigatorios && this.tiposDocumentosObrigatorios.length > 0) {
        const tiposObrigatorios = this.tiposDocumentosObrigatorios.map(tipoDocumentoObrigatorio => tipoDocumentoObrigatorio.descricao)

        let infoTipoDocumentosObrigatorios = 'Documentos obrigatórios:'

        tiposObrigatorios.forEach(documento => { // eslint-disable-line
          infoTipoDocumentosObrigatorios += '<br> - '
          infoTipoDocumentosObrigatorios += documento
        })
        return infoTipoDocumentosObrigatorios
      }
      return ''
    },
    validationValues () {
      return { documentos: this.documentos, documentosObrigatorios: this.tiposDocumentosObrigatorios }
    },
  },

  methods: {
    anexar (documento) {
      this.$emit('addDoc', documento)
    },
    deleteRow (row, index) {
      this.$emit('removeDoc', {row, index})
    },
    requireDocumentosObrigatorios () {
      return this.tiposDocumentosObrigatorios ? 'documentosObrigatorios' : ''
    },
    tipoDocumentoOnChange(tipo) {
      this.$emit('tipoDocumentoOnChange', tipo)
    }
  },
}
</script>

<style lang="scss" scoped>
.input {
  margin-top: 20px !important;
}
</style>
